<template>
  <div @click="selectSlot" :style="boxHeight" class="highlight-container">
    <div class="highlight-info">
      <span class="highlight-text">
        <IconBase
          icon-name="check"
          iconColor="#efefef"
          viewBox="0 0 512 512"
          width="100%"
          height="100%"
          strokeWidth="0px"
          ><IconCheck
        /></IconBase>
      </span>
      <!-- <span class="high">Select</span> -->
      <!-- <span class="high" v-if="!hasSomeone">Select</span> -->
      <span class="high2" v-if="!hasSomeone">Select</span>
    </div>
  </div>
</template>

<script>
import IconBase from "../../../../components/IconBase";
import IconCheck from "../../../../components/SVG/IconCheck";

export default {
  name: "SlotHoverEmpty",
  props: [
    "slotDateTimeMS", 
    "boxHeight", 
    "heightNum", 
    "hasSomeone"
  ],
  computed: {
    getCoverStyle() {
      let style = `height:calc(100% - ${this.heightNum}px); margin-top: calc(${this.heightNum}px - 4px);`;
      return style;
    },
  },
  components: {
    IconBase,
    IconCheck,
  },
  methods: {
    selectSlot() {
      this.$emit("handleSlotSelection", this.slotDateTimeMS);
      this.$nextTick(function() {
        this.scrollToNewestSelection();
      })
    },

    scrollToNewestSelection() {
      let selections = document.getElementById("groups");

      let selectionTimeInMS = this.slotDateTimeMS;

      let latestSelection = document.getElementById(selectionTimeInMS);
      if (latestSelection) {
        let topPos = latestSelection.offsetTop;

        selections.scrollTop = topPos - 10;

        this.handleSelectionInView(latestSelection);
        setTimeout(() => {
          this.handleSelectionInView(latestSelection);
        }, 300);
      }
    },

    handleSelectionInView(selection) {
      if (selection.classList.contains("just-selected")) {
        console.log("here");
        selection.classList.remove("just-selected");
      } else {
        console.log("ADD");
        selection.classList.add("just-selected");
      }
    },
  },
};
</script>

<style scoped>
.calendar .highlight-info {
  /* background-color: #eef1f4; */
  border-radius: 4px;
  height: 92%;
  height: 96%;
  height: 94%;
  width: 96%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  pointer-events: auto;
  /* box-shadow: 0px 1px 2px 0px #cccccc; */
  border-radius: 2px;
  color: #323333;
  font-size: 16px;
  background-color: #fafafb85;
  /* background-color: #fafafb; */
  border: 1px solid #efefef;
  border: 1px solid #efefef;
  border-radius: var(--calendar-box-border-radius);
}

.high {
  position: absolute;
  top: 3px;
  left: 3px;
  z-index: 9999;
  background-color: #2f2f2f5c;
  background-color: #2d2d2d;
  padding: 2px 0px;
  border-radius: 360px;
  font-weight: bold;
  width: 39%;
  font-size: 14px;
  color: #4a4a4a;
  color: white;
}

.high2 {
  position: absolute;
  top: 4px;
  left: 33px;
  z-index: 9999;
  /* background-color: #2f2f2f5c; */
  /* background-color: #2d2d2d; */
  padding: 2px 0px;
  /* border-radius: 360px; */
  font-weight: 700;
  width: 39%;
  font-size: 15px;
  color: #323333;
  font-size: 14px;
  color: #383838;
}

span.highlight-text {
  position: absolute;
  top: -3px;
  left: 3px;
  z-index: 9999;
  /* background-color: #2f2f2f5c; */
  /* background-color: #2d2d2d; */
  /* padding: 2px 0px; */
  border-radius: 360px;
  font-weight: bold;
  /* width: 39%; */
  /* font-size: 14px; */
  color: #4a4a4a;
  color: white;
  width: 22px;
  height: 22px;
  width: 30px;
  height: 30px;
}
</style>